<template>
  <div>
    <page-section
      :title="$t('Integrations_Overview_Information')"
      class="information"
    >
      <form-section>
        <div v-html="info"></div>
      </form-section>
    </page-section>

    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="['kochava_sync_installs']"
    />
  </div>
</template>

<script>
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
import PageSection from '@/common/components/page/PageSection'
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'KochavaOverview',

  components: {
    FormSection,
    PageSection,
    IntegrationTasksTable
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    info() {
      if (this.model.params.disable_event_forwarding) {
        return this.$t('Integrations_Kochava_Text_Information_NoForwarding')
      } else {
        return this.$t('Integrations_Kochava_Text_Information')
      }
    }
  }
}
</script>

<style scoped>
>>> .information ul {
  list-style-type: disc;
}

>>> .information ul li {
  margin-left: 20px;
  margin-bottom: 8px;
}

>>> .information ul li:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/kochava/KochavaOverview.vue